import classNames from "classnames";
import { FC } from "react";

import {
  DIVIDER_ORIENTATION_CLASSES,
  DIVIDER_SPACING_CLASSES,
  DIVIDER_THICKNESS_CLASSES,
  DIVIDER_TONE_CLASSES,
} from "./Divider.constants";
import { DividerProps } from "./Divider.types";

export const Divider: FC<DividerProps> = ({
  orientation = "horizontal",
  spacing = "md",
  thickness = "sm",
  tone = "default",
  className,
}) => {
  return (
    <div
      aria-hidden={"true"}
      className={classNames(
        "shrink-0",
        DIVIDER_ORIENTATION_CLASSES[orientation],
        DIVIDER_SPACING_CLASSES[orientation][spacing],
        DIVIDER_THICKNESS_CLASSES[orientation][thickness],
        DIVIDER_TONE_CLASSES[tone],
        className,
      )}
    />
  );
};
